// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2HGLdl9LFRhEnv {\n  cursor: pointer;\n  display: flex;\n  width: 304px;\n}\n.qWgSZvv9PcUkB7 {\n  cursor: default;\n  margin: 16px 0 0 0;\n  width: 100%;\n}\n.anCvdclLBqPvDx {\n  justify-self: start;\n  width: max-content;\n  text-decoration: none;\n}\n.cBRl5NP04c0EeA {\n  border-radius: 3px;\n  font-weight: normal;\n  height: 24px;\n  line-height: 16px;\n  margin: 0;\n  padding: 4px 8px;\n  min-width: 64px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"powerUpItem": "_2HGLdl9LFRhEnv",
	"listingPowerUpItem": "qWgSZvv9PcUkB7",
	"buttonAnchor": "anCvdclLBqPvDx",
	"addButton": "cBRl5NP04c0EeA"
};
export default ___CSS_LOADER_EXPORT___;
